import { createV2EventTracker } from '../util';
import { BulkActionAnalytics, BulkActionFailure, ExportAalytics } from './types';

export const trackExport = createV2EventTracker<ExportAalytics>('DX Object Export');

export const trackBulkActionSuccess =
  createV2EventTracker<BulkActionAnalytics>('BulkActionSuccess');

export const trackBulkActionFailure = createV2EventTracker<BulkActionFailure>('BulkActionFailure');
